export default __webpack_public_path__ + "static/media/group_image.6bd9fd37.svg";